export class KnowledgeItemExclusionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async excludeKnowledgeItem({ knowledgeItemId }) {
    return this.#http.post(`/knowledge-items/${knowledgeItemId}/exclusion`);
  }

  async includeKnowledgeItem({ knowledgeItemId }) {
    return this.#http.delete(`/knowledge-items/${knowledgeItemId}/exclusion`);
  }
}
